import { render, staticRenderFns } from "./AdminPanelEGiftsPackageSellingHistoryEdit.vue?vue&type=template&id=34d7588b&"
import script from "./AdminPanelEGiftsPackageSellingHistoryEdit.vue?vue&type=script&lang=js&"
export * from "./AdminPanelEGiftsPackageSellingHistoryEdit.vue?vue&type=script&lang=js&"
import style0 from "./AdminPanelEGiftsPackageSellingHistoryEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VFlex,VIcon,VSimpleTable,VSubheader,VTextField,VToolbar,VToolbarTitle})
